'use strict';
const ansiRegex = require('ansi-regex');

const stripAnsi = string => typeof string === 'string' ? string.replace(ansiRegex(), '') : string;

module.exports = stripAnsi;
module.exports.default = stripAnsi;



//////////////////
// WEBPACK FOOTER
// ./~/ora/~/strip-ansi/index.js
// module id = 2546
// module chunks = 0 1